import { render, staticRenderFns } from "./AutoAcceptSettings.vue?vue&type=template&id=131d0bd0"
import script from "./AutoAcceptSettings.vue?vue&type=script&lang=js"
export * from "./AutoAcceptSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports